import { useEffect, useState } from "react";
import { getOffices } from "../api/officeService";

export const useOffices = () => {
    const [offices, setOffices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getOffices()
        .then(setOffices)
        .finally(() => setLoading(false));
    }, []);

    return { offices, loading, setOffices };
};
